$(function () {
	var app_content = $('#body-settings #content');
	var app_acc_menu = $('#personal-settings');
	var app_pass_menu = $('#security-password');
	
	// Execute request only if any of forms exists, otherwise just show settings content
	if (!app_acc_menu.length && !app_pass_menu.length){
		app_content.css('opacity', '1');
		return;
	}

	$.get(OC.generateUrl('/apps/ecit_10_users/settings/editables'),function(response){

		var avatar = response.data.avatar;
		var pass = response.data.password;


		if(!avatar){
			$('#uploadavatarbutton').remove();
			$('#selectavatar').remove();
			$('#displayavatar p').remove();
		}
		
		if(!pass){
			app_pass_menu.remove();
			$('#security-webauthn').remove();
			$('#security div').remove();
		}

		// Show content when script did the work
		app_content.css('opacity', '1');
	});
});
